import { createSlice } from "@reduxjs/toolkit";

interface SystemPrecheckType {
    overallSystemPreCheckStatus:OverallSystemPreCheckStatus 
}

const initialState:SystemPrecheckType = {
    overallSystemPreCheckStatus: 'running'
}

const systemPrecheckSlice = createSlice({
    name:"systemPrecheckSlice",
    initialState,
    reducers:{
        updateSystemStatus: (state,action)=> {
            state.overallSystemPreCheckStatus = action.payload
        }
    }

})

export const {updateSystemStatus} = systemPrecheckSlice.actions
export default systemPrecheckSlice.reducer